import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import './index.scss';
import { ChanelConfig } from '../../../configs/GlobalConfig';
import MessageHub from '../../../core/signalr/SignalrMessageHub';
import ConstCommon from '../../common/Const';
import PreRender from '../../common/PreRender';
import {
  getCodeFromQuery,
  getQueryParams,
  removeDragCode,
} from '../../helpers/Common';
import CurrentState from '../../helpers/CurrentState';
import FinancialRatioContent from './FinancialRatioContent';
import {
  changeSearchParams,
  fetchCompanyScore,
  fetchInfoTicker,
  REDUCER_NAME,
  setRealtimeData,
  unmountComponent,
} from './reducer';

class FinancialRatio extends React.PureComponent {
  constructor(props) {
    super(props);
    const { changeSearchParams, id } = this.props;
    const codeFromQuery = getCodeFromQuery(['stock']);
    if (codeFromQuery) {
      changeSearchParams(id, codeFromQuery);
    }
  }

  componentDidMount() {
    const { glContainer } = this.props;
    var code = getQueryParams('code');
    if (!getQueryParams('code')) {
      this.fetchData();
    }
    removeDragCode(glContainer);
    MessageHub.subscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { searchParams, compares, isFilterIndustry, id } = this.props;
    if (searchParams.code !== prevProps.searchParams.code) {
      this.fetchData();
    }
    if (compares !== prevProps.compares) {
      CurrentState.add(
        ConstCommon.listComponent.FinancialRatio,
        'compares',
        compares,
        id,
      );
    }

    if (isFilterIndustry !== prevProps.isFilterIndustry) {
      CurrentState.add(
        ConstCommon.listComponent.FinancialRatio,
        'isFilterIndustry',
        isFilterIndustry,
        id,
      );
    }
  }

  componentWillUnmount() {
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
  }

  onReceiveTicker = data => {
    const {
      searchParams: { code },
      id,
      setRealtimeData,
    } = this.props;
    const realtimeData = data.find(item => item.organCode === code);
    if (realtimeData) {
      setRealtimeData(id, realtimeData);
    }
  };

  fetchData = () => {
    const { fetchCompanyScore, searchParams, id, fetchInfoTicker } = this.props;
    fetchCompanyScore(id, searchParams.code);
    fetchInfoTicker(id, searchParams.code);
  };

  render() {
    const { componentData } = this.props;
    if (!componentData) {
      return null;
    }

    return (
      <PreRender {...this.props}>
        <FinancialRatioContent {...this.props} />
      </PreRender>
    );
  }
}

const mapStateToProps = (state, { id }) => ({
  componentData: state[REDUCER_NAME][id],
  searchParams: state[REDUCER_NAME][id].searchParams,
  isFilterIndustry: state[REDUCER_NAME][id].isFilterIndustry,
  compares: state[REDUCER_NAME][id].compares,
  timeFilter: state[REDUCER_NAME][id].timeFilter,
  locale: state.i18n.locale,
  code: state[REDUCER_NAME][id].searchParams.organCode,
});

const mapDispatchToProps = {
  fetchCompanyScore,
  fetchInfoTicker,
  setRealtimeData,
  changeSearchParams,
  unmountComponent,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(FinancialRatio);
